import { DatesBetween } from './DatesBetween';
import { DateWithCount } from './DateWithCount';
import {
  DetailDescriptionEmployeeAlertAgeOutOfRange,
  DetailDescriptionEmployeeAlertDuplicateCompanyContracts,
  DetailDescriptionEmployeeAlertFirstContractStartDateNotSameAsHiredDate,
  DetailDescriptionEmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate,
  DetailDescriptionEmployeeAlertInactiveManager,
  DetailDescriptionEmployeeAlertInvalidEmployeeCode,
  DetailDescriptionEmployeeAlertInvalidJapanesePhoneticName,
  DetailDescriptionEmployeeAlertInvalidLegalFullName,
  DetailDescriptionEmployeeAlertInvalidPreferredFullName,
  DetailDescriptionEmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate,
  DetailDescriptionEmployeeAlertLastContractEndDateNotSameAsResignationDate,
  DetailDescriptionEmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate,
  DetailDescriptionEmployeeAlertLastWorkingDateBeforeHiredDate,
  DetailDescriptionEmployeeAlertProbationFailedStillEmployed,
  DetailDescriptionEmployeeAlertResignationDateBeforeHiredDate,
  DetailDescriptionEmployeeAlertResignationDateBeforeLastWorkingDate,
} from './detail-description';
import { FormattedDate } from './FormattedDate';
import type { EmployeeAlertListItemReason } from './types';

interface Props {
  reason: EmployeeAlertListItemReason;
  className?: string;
}

export const EmployeeAlertDetailDescription = ({ reason, className }: Props) => {
  let element = <></>;

  switch (reason.__typename) {
    case 'EmployeeAlertAgeOutOfRange':
      element = <DetailDescriptionEmployeeAlertAgeOutOfRange reason={reason} />;
      break;
    case 'EmployeeAlertContractsNotContinuous':
      element = <DatesBetween date1={reason.date1} date2={reason.date2} gapDays={reason.gapDays} />;
      break;
    case 'EmployeeAlertInactiveManager':
      element = <DetailDescriptionEmployeeAlertInactiveManager reason={reason} />;
      break;
    case 'EmployeeAlertInvalidEmployeeCode':
      element = <DetailDescriptionEmployeeAlertInvalidEmployeeCode reason={reason} />;
      break;
    case 'EmployeeAlertInvalidJapanesePhoneticName':
      element = <DetailDescriptionEmployeeAlertInvalidJapanesePhoneticName reason={reason} />;
      break;
    case 'EmployeeAlertInvalidLegalFullName':
      element = <DetailDescriptionEmployeeAlertInvalidLegalFullName reason={reason} />;
      break;
    case 'EmployeeAlertInvalidPreferredFullName':
      element = <DetailDescriptionEmployeeAlertInvalidPreferredFullName reason={reason} />;
      break;
    case 'EmployeeAlertEmployeeNotInactiveButNoActiveContract':
      element = <DateWithCount prefix="Last contract end date" date={reason.lastContractEndDate} />;
      break;
    case 'EmployeeAlertEmployeeNotInactiveButNoActiveJobHistory':
      element = <DateWithCount prefix="Last job history end date" date={reason.lastJobHistoryEndDate} />;
      break;
    case 'EmployeeAlertResignationDateBeforeAnyMindStarts':
      element = <FormattedDate prefix="Employment end date" date={reason.resignationDate} />;
      break;
    case 'EmployeeAlertResignationDateBeforeHiredDate':
      element = <DetailDescriptionEmployeeAlertResignationDateBeforeHiredDate reason={reason} />;
      break;
    case 'EmployeeAlertResignationDateBeforeLastWorkingDate':
      element = <DetailDescriptionEmployeeAlertResignationDateBeforeLastWorkingDate reason={reason} />;
      break;
    case 'EmployeeAlertFirstContractStartDateNotSameAsHiredDate':
      element = <DetailDescriptionEmployeeAlertFirstContractStartDateNotSameAsHiredDate reason={reason} />;
      break;
    case 'EmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate':
      element = <DetailDescriptionEmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate reason={reason} />;
      break;
    case 'EmployeeAlertHiredDateBeforeAnyMindStarts':
      element = <FormattedDate prefix="Hired date" date={reason.hiredDate} />;
      break;
    case 'EmployeeAlertJobHistoriesNotContinuous':
      element = <DatesBetween date1={reason.date1} date2={reason.date2} gapDays={reason.gapDays} />;
      break;
    case 'EmployeeAlertLastContractEndDateNotSameAsResignationDate':
      element = <DetailDescriptionEmployeeAlertLastContractEndDateNotSameAsResignationDate reason={reason} />;
      break;
    case 'EmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate':
      element = <DetailDescriptionEmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate reason={reason} />;
      break;
    case 'EmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate':
      element = <DetailDescriptionEmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate reason={reason} />;
      break;
    case 'EmployeeAlertLastWorkingDateBeforeAnyMindStarts':
      element = <DateWithCount prefix="Last working date" date={reason.lastWorkingDate} />;
      break;
    case 'EmployeeAlertLastWorkingDateBeforeHiredDate':
      element = <DetailDescriptionEmployeeAlertLastWorkingDateBeforeHiredDate reason={reason} />;
      break;
    case 'EmployeeAlertLastContractWillEnd':
      element = <DateWithCount prefix="Last contract end date" date={reason.lastEndDate} />;
      break;
    case 'EmployeeAlertLastJobHistoryWillEnd':
      element = <DateWithCount prefix="Last job history end date" date={reason.lastEndDate} />;
      break;
    case 'EmployeeAlertDuplicateCompanyContracts':
      element = <DetailDescriptionEmployeeAlertDuplicateCompanyContracts reason={reason} />;
      break;
    case 'EmployeeAlertProbationFailedStillEmployed':
      element = <DetailDescriptionEmployeeAlertProbationFailedStillEmployed />;
      break;
    default:
      return <></>;
  }

  return (
    <div className={className || 'text-xs'} data-typename={reason.__typename}>
      {element}
    </div>
  );
};
